// extracted by mini-css-extract-plugin
export default {"loadingMessageBox":"loadingMessageBox-y39k8"};